<template>
	<div class="c-empty-state">
		<div v-if="!loaded">
			<div class="spinner">
				<div class="double-bounce1"></div>
				<div class="double-bounce2"></div>
			</div>
		</div>
		<div v-else>
			<div v-if="notes.length > 0">
				<x-icon size="2.5x" class="custom-class"></x-icon>
				<h3>
					{{ text }}
				</h3>
				<h5 v-html="subtext"></h5>
			</div>
			<div v-else>
				<h3>You haven't saved any highlights or bookmarks.</h3>
				<p>
					This place is looking empty, try
					<a href="#" @click.prevent="$bvModal.show('modal-bookmark')"
						>adding a bookmark</a
					>
					for now.
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import { XIcon } from 'vue-feather-icons';
export default {
	components: {
		XIcon,
	},
	computed: {
		loaded: function () {
			return this.$store.getters.loaded;
		},
		init: function () {
			return this.$store.getters.init;
		},
		notes: function () {
			return this.$store.getters['note/notes'];
		},
		search: function () {
			return this.$store.getters['dashboard/search'];
		},
		folder: function () {
			return this.$store.getters['dashboard/folder'];
		},
		text: function () {
			let text = 'No Annotations could be found';
			if (this.search) {
				text = "We couldn't find any Annotations";
			}
			if (this.folder) {
				text = 'No Highlights in this folder';
			}
			return text;
		},
		subtext: function () {
			let text = '';
			if (this.folder) {
				text =
					'Add Highlights to this folder and they will show up here.<br /> You can drag highlights directly into the sidebar.';
			}
			if (this.search) {
				text = 'Search for another term';
			}
			return text;
		},
	},
};
</script>

<style lang="scss">
.c-empty-state {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
	text-align: center;

	svg {
		stroke-width: 1px;
	}

	&__diagram {
		display: flex;
		margin-bottom: var(--spacer-sm);

		&__item {
			margin: 0 var(--margin);
			padding: var(--margin) var(--margin-lg);
			border-radius: var(--border-radius);
			border: var(--g1) solid 2px;
		}
	}

	@include media-breakpoint-down(xs) {
		width: 100%;
		padding: 0 30px;
	}

	.spinner {
		width: 40px;
		height: 40px;

		position: relative;
		margin: 100px auto;
	}

	.double-bounce1,
	.double-bounce2 {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		background-color: var(--p3);
		opacity: 0.6;
		position: absolute;
		top: 0;
		left: 0;

		-webkit-animation: sk-bounce 2s infinite ease-in-out;
		animation: sk-bounce 2s infinite ease-in-out;
	}

	.double-bounce2 {
		-webkit-animation-delay: -1s;
		animation-delay: -1s;
	}

	@-webkit-keyframes sk-bounce {
		0%,
		100% {
			-webkit-transform: scale(0);
		}
		50% {
			-webkit-transform: scale(1);
		}
	}

	@keyframes sk-bounce {
		0%,
		100% {
			transform: scale(0);
			-webkit-transform: scale(0);
		}
		50% {
			transform: scale(1);
			-webkit-transform: scale(1);
		}
	}
}
</style>